import React from 'react';
import ReactDOM from 'react-dom/client';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { Provider } from 'react-redux';
import App from './app';
import theme from './theme';
import { store } from './store';
import { AuthInitializer } from './auth/auth-initializer';
import './styles/index.scss';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <AuthInitializer>
          <App />
        </AuthInitializer>
      </ThemeProvider>
    </Provider>
  </React.StrictMode>
);
